import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/index.vue')
  },
  {
    path:'/test1',
    component: () => import('@/components/test.vue')
  },{
    path:'/BalloonGame',
    component: () => import('@/views/BalloonGame.vue')
  },{
    path:'/TypingTrainer',
    component: () => import('@/views/TypingTrainer.vue')
  },
  {
    path:'/print',
    component: () => import('@/views/test.vue')
  },
  {
    path:'/comment',
    component: () => import('@/components/comment.vue')
  },
  {
    path:'/phone',
    component: () => import('@/views/phone.vue')
  },
  {
    path: '/gameCenter',
    name: 'gameCenter',
    component: () => import('@/components/game.vue')
  },
  {
    path: '/personalWorks',
    name: 'personalWorks',
    component: () => import('@/views/personalWorks.vue')
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/components/download/newDownload.vue')
  },
  {
    path: "/rechargeRecords",
    name: "rechargeRecords",
    component: () => import("@/views/rechargeRecords.vue"),
  },
  {
    path: '/personSetting',
    name: 'personSetting',
    component: () => import('@/views/personalSettings.vue')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test.vue')
  },
  {
    path: '/evaluation',
    name: 'evaluation',
    component: () => import('@/views/evaluation.vue')
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
//全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.fullPath == '/1'||to.fullPath == '/2') {
    next('/');
  } else {
    next();
  }
})
export default router
